import React from 'react';
import { Container, AppBar, Toolbar, Button } from '@material-ui/core';
import useStyles from './Page.styles';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectLoggedIn, logout } from '../../../features/auth/state';
import { ROLES } from '../../roles.enum';

const links = [
  {name: 'Lab results', path: '/lab-results', roles: [ROLES.PHYSICIAN_OVERSIGHT]},
  {name: 'Audit trail', path: '/audit-trail', roles: [ROLES.AUDIT_TRAIL]},
  {name: 'User tracker', path: '/user-tracker', roles: [ROLES.USER_TRACKER]},
  {name: 'User submitted lab results', path: '/user-submitted-lab-results',  roles: [ROLES.SUPPORT]}
];

export function Page({children}: {children: any}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const auth = useSelector(selectLoggedIn);
  const roles = auth?.attributes.find(({Name}: any) => Name === 'custom:roles');
  const parsedUserRoles = roles?.Value.split(',') || [];
  return (
    <Container maxWidth={false}>
      <AppBar position="static">
        <Toolbar>
          <div className={classes.title}>
            {auth ? (
              <React.Fragment>
                {
                  links
                    .filter((link) => !!link.roles.find(r => parsedUserRoles.includes(r)))
                    .map((link) => (
                      <Button key={link.path} color="inherit" component={NavLink}
                        to={link.path} activeClassName={classes.active} exact={true}>
                        {link.name}
                      </Button>
                    ))
                }
              </React.Fragment>
            ) : null}
          </div>
          {auth ? (
            <Button color="inherit" onClick={() => dispatch(logout())}>
              Logout
            </Button>
          ) : null}
        </Toolbar>
      </AppBar>
      {children}
    </Container>
  );
}